import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["beforeBack", "buttonLabel", "disableColorRemap", "children"];
import { useContext } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import TourContext from '../contexts/TourContext';
import handleCallback from '../lib/handleCallback';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UITourBackButtonLegacy = props => {
  const {
    tour
  } = useContext(TourContext);
  const {
      beforeBack = emptyFunction,
      children = /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "100",
        children: [/*#__PURE__*/_jsx(LeftIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "shepherd-react.back"
        })]
      })
    } = props,
    buttonProps = _objectWithoutPropertiesLoose(props, _excluded);
  if (!tour.canGoBack()) {
    return /*#__PURE__*/_jsx("div", {});
  }
  const {
    back,
    getTour,
    getStep
  } = tour;
  const handleClick = evt => {
    const {
      tourKey = getTour(),
      stepKey = getStep()
    } = props;
    if (props.onClick) {
      props.onClick(evt);
    }
    handleCallback(beforeBack, back, {
      tourKey,
      stepKey
    });
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
    onClick: handleClick,
    children: children
  }));
};
export default UITourBackButtonLegacy;